<template>
  <div class="table">
    <div class="thead">
      <div class="tr">
        <div class="th">
          Indicators
        </div>

        <div class="th">
          Baseline
        </div>

        <template
          v-for="year in years"
          :key="year.key"
        >
          <div class="th">
            {{ year.label }}
            <span class="block">Target</span>
          </div>

          <div
            v-if="year.key !== 'year5'"
            class="th bg-[#F4F4F4]"
          >
            {{ year.label }}
            <span class="block">Actual</span>
          </div>
        </template>
      </div>
    </div>

    <div class="tbody">
      <div
        v-for="(row, rIdx) in contentItem.rows"
        :key="rIdx"
        class="tr"
      >
        <div class="td">
          <span class="font-semibold">{{ row.indicator }}</span>

          <div
            class="block font-bold"
            v-html="domPurify.sanitize(row.description)"
          />
        </div>

        <div class="td !text-right">
          {{ formatThousands(row.baseline) }}
        </div>

        <template
          v-for="year in years"
          :key="year.key"
        >
          <div class="td !text-right">
            {{ formatThousands(row[year.key]?.target) }}
          </div>

          <div
            v-if="year.key !== 'year5'"
            class="td !text-right bg-[#F4F4F4]"
          >
            {{ formatThousands(row[year.key]?.actual) }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useDomPurify, useStringFormatter } from '@/composables';

const domPurify = useDomPurify();
const { formatThousands } = useStringFormatter();

defineProps({
  contentItem: {
    type: Object,
    required: true,
  },
});

const years = [
  { key: 'year1', label: 'Year 1' },
  { key: 'year2', label: 'Year 2' },
  { key: 'year3', label: 'Year 3' },
  { key: 'year4', label: 'Year 4' },
  { key: 'year5', label: 'Year 5' },
];
</script>
